export enum SpecialCause {
	UpdateLastSyncedWhen,
	AutoTaskifySearchResult,
}
